import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
  type ReactNode,
} from "react";

type WhisperImmersiveContextValue = {
  immersive: boolean;
  setImmersive: (value: boolean) => void;
};

const WhisperImmersiveContext =
  createContext<WhisperImmersiveContextValue | null>(null);

export function WhisperImmersiveProvider({ children }: { children: ReactNode }) {
  const [immersive, setImmersiveState] = useState(false);
  const setImmersive = useCallback((value: boolean) => {
    setImmersiveState(value);
  }, []);
  const value = useMemo(
    () => ({ immersive, setImmersive }),
    [immersive, setImmersive],
  );
  return (
    <WhisperImmersiveContext.Provider value={value}>
      {children}
    </WhisperImmersiveContext.Provider>
  );
}

export function useWhisperImmersive() {
  const ctx = useContext(WhisperImmersiveContext);
  if (!ctx) {
    throw new Error("useWhisperImmersive must be used within WhisperImmersiveProvider");
  }
  return ctx;
}
